import { EnvironmentSettingsService } from '../../../shared-services/environment-settings.service';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ServiceSubscriptionEditorService } from './service-subscription-editor.service';
import { ConfirmDialogService } from '../../../core/components/confirm-dialog/confirm-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { AddFrequencyModel } from './models/addFrequencyModel';
import { EditServiceSubscriptionModel } from './models/editServiceSubscriptionModel';
import { SubscriptionServiceTypeModel } from './models/subscriptionServiceTypeModel';
import { ConsoleLogger } from '../../../core/utilities/console-logger';
import { CompanyDropdownResponse } from '../../../fleet-manager/company/models/responses';
import { SetSubscriptionRateModel } from './models/setSubscriptionRateModel';
import { CommonService } from '../../../shared/common/common.service';

@Component({
	selector: 'app-service-subscription-editor',
	templateUrl: './service-subscription-editor.component.html',
	styleUrls: ['./service-subscription-editor.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ServiceSubscriptionEditorComponent implements OnInit, OnDestroy {
	@ViewChild('subscriptionTable') subscriptionTable: any;

	public rows: any[];
	public filterRows: any[];
	public companyServices: any[];
	public companyRows: CompanyDropdownResponse[];
	public frequencyRows: any[];
	public serviceCodeList: any[];
	public chargeTypesList: any[];
	public rateDropdown: any[];

	todaysDate: string;
	taxRate: number;
	taxRateSubscription$: Subscription;
	tableColumns: { name: string; prop: string; width: number }[];
	subTableColumns: { name: string; prop: string; width: number }[];

	//filters
	public filterCompany: number = null;
	public filterStartingDay: number = null;
	public filterStartingMonth = -1;
	public filterBillingFrequency = -1;
	public filterService = -1;
	public filterDescription = '';
	public filterHasOverride = '';
	public filterIsActive = '';
	public filterEnrolledDateStart: Date = null;
	public filterEnrolledDateEnd: Date = null;
	public filterStartDateStart: Date = null;
	public filterStartDateEnd: Date = null;
	public invoiceCompanyId = 7340;

	constructor(
		private environmentSettingsService: EnvironmentSettingsService,
		public confirmDialogService: ConfirmDialogService,
		private commonService: CommonService,
		private serviceSubscriptionService: ServiceSubscriptionEditorService,
		private toastrService: ToastrService
	) {}

	ngOnInit() {
		this.todaysDate = new Date().toISOString();

		this.taxRateSubscription$ = this.environmentSettingsService.currentTaxRate$.subscribe(
			(taxRate) => (this.taxRate = taxRate)
		);

		this.tableColumns = [
			{ name: 'Description', prop: 'description', width: 300 },
			{ name: 'Service', prop: 'serviceTypeIds', width: 300 },
			{ name: 'Billing Frequency', prop: 'frequencyId', width: 150 },
			{ name: 'Execution Time', prop: 'executionTime', width: 150 },
			{ name: 'Staring Month', prop: 'startMonth', width: 100 },
			{ name: 'Starting Day', prop: 'startDay', width: 100 },
			{ name: 'Auto Approved', prop: 'isAutoApproved', width: 100 },
			{ name: 'Active?', prop: 'isActive', width: 100 },
			{ name: '', prop: '', width: 200 },
		];
		this.subTableColumns = [
			{ name: 'Description', prop: 'name', width: 250 },
			{ name: 'Charge Type', prop: 'chargeTypeId', width: 150 },
			{ name: 'Service Code', prop: 'serviceCodeId', width: 150 },
			{ name: 'Charge Frequency', prop: 'isRecurring', width: 150 },
			{ name: 'End of Month', prop: 'isEndOfMonth', width: 50 },
			{
				name: 'Charge Notes  (## for multiplier value)',
				prop: 'noteTemplate',
				width: 250,
			},
		];

		this.loadRows();
		this.serviceSubscriptionService
			.getCompanyServices(null)
			.toPromise()
			.then((cs) => {
				this.companyServices = cs;
			});
		this.serviceSubscriptionService
			.getCompanyDropdown()
			.toPromise()
			.then((data: CompanyDropdownResponse[]) => {
				this.companyRows = data.sort((a, b) =>
					a.companyId < b.companyId ? -1 : 1
				);
				this.companyRows.forEach((element) => {
					element.fullName = element.companyId + ' - ' + element.companyName;
				});
			});
		this.serviceSubscriptionService
			.getFrequencyDropdown()
			.toPromise()
			.then((freq: any) => {
				this.frequencyRows = freq;
			});
		this.serviceSubscriptionService
			.getRateDropdown()
			.toPromise()
			.then((data: any) => {
				this.rateDropdown = data;
			});
		this.serviceSubscriptionService
			.getServiceCodeDropdown()
			.toPromise()
			.then((data: any) => {
				this.serviceCodeList = data;
			});
		this.serviceSubscriptionService
			.getChargeTypes()
			.toPromise()
			.then((data) => {
				this.chargeTypesList = [];
				data.forEach((d) => {
					if (d.id < 4) {
						this.chargeTypesList.push(d);
					}
				});
			});
	}

	ngOnDestroy() {
		if (this.taxRateSubscription$) {
			this.taxRateSubscription$.unsubscribe();
		}
	}

	loadRows() {
		this.serviceSubscriptionService
			.getList(false)
			.toPromise()
			.then((rows: any) => {
				ConsoleLogger.logInfo(
					'serviceSubscriptionService.getList(false)',
					rows
				);
				this.rows = rows;
				this.filterTable();
			});
	}

	public toggleExpandRow(row) {
		this.subscriptionTable.rowDetail.toggleExpandRow(row);
		if (!row.rates) {
			this.loadRates(row);
		}
	}

	loadRates(row) {
		row.rates = null;
		this.serviceSubscriptionService
			.getRateList(row.id, [])
			.toPromise()
			.then((rates) => {
				ConsoleLogger.logInfo(
					`this.serviceSubscriptionService.getRateList(${row.id},[])`,
					rates
				);
				row.rates = rates;
				row.rates.forEach((rate) => {
					rate.subscriptionId = row.id;
				});
			});
	}

	public filterTable() {
		if (this.rows) {
			this.filterRows = this.rows.filter((row) => {
				return (
					(this.filterCompany == null ||
						row.companyId == +this.filterCompany) &&
					(this.filterStartingDay == null ||
						this.filterStartingDay < 1 ||
						row.startDay == +this.filterStartingDay) &&
					(+this.filterStartingMonth == -1 ||
						row.startMonth == +this.filterStartingMonth) &&
					(+this.filterBillingFrequency == -1 ||
						row.frequencyId == +this.filterBillingFrequency) &&
					(+this.filterService == -1 ||
						row.serviceTypeIds.filter((sti) => {
							return sti == +this.filterService;
						}).length > 0) &&
					(this.filterDescription.trim() == '' ||
						row.description
							.toLowerCase()
							.includes(this.filterDescription.trim().toLowerCase())) &&
					(this.filterHasOverride.trim() == '' ||
						(this.filterHasOverride == 'Yes' &&
							row.isAutoApproved != row.isAutoApprovedOverride) ||
						(this.filterHasOverride == 'No' &&
							row.isAutoApproved == row.isAutoApprovedOverride)) &&
					(this.filterIsActive.trim() == '' ||
						(this.filterIsActive == 'No' &&
							row.endDate &&
							row.endDate <= this.todaysDate) ||
						(this.filterIsActive == 'Yes' &&
							(!row.endDate || row.endDate > this.todaysDate))) &&
					(this.filterEnrolledDateStart == null ||
						this.filterEnrolledDateStart <= row.enrolledDate) &&
					(this.filterEnrolledDateEnd == null ||
						this.filterEnrolledDateEnd >= row.enrolledDate) &&
					(this.filterStartDateStart == null ||
						this.filterStartDateStart <= row.startDate) &&
					(this.filterStartDateEnd == null ||
						this.filterStartDateEnd >= row.startDate)
				);
			});
		} else {
			this.filterRows = [];
		}
	}

	editMode(row) {
		row.editDescription = row.description;
		row.editServiceTypeIds = row.serviceTypeIds;
		row.editFrequencyId = row.frequencyId;
		row.editExecutionTime = row.executionTime;
		row.editStartMonth = row.startMonth;
		row.editStartDay = row.startDay;
		row.editStartWeekDay = row.startWeekDay;
		row.editIsAutoApproved = row.isAutoApproved ? 'Yes' : 'No';
		if (row.editMode) {
			row.editMode = !row.editMode;
		} else {
			row.editMode = true;
		}
	}

	closeEditAfterSave(row) {
		row.description = row.editDescription;
		row.serviceTypeIds = row.editServiceTypeIds;
		row.frequencyId = row.editFrequencyId;
		row.executionTime = row.editExecutionTime;
		row.startMonth = +row.editStartMonth;
		row.startDay = row.editStartDay;
		row.startWeekDay = row.editStartWeekDay;
		row.isAutoApproved = row.editIsAutoApproved == 'Yes' ? true : false;
		row.editMode = false;
	}

	addNewService() {
		const newRow = {
			id: 0,
			description: '',
			serviceTypeIds: [],
			frequencyId: -1,
			executionTime: null,
			startMonth: -1,
			startDay: -1,
			isAutoApproved: false,
			isActive: true,
			editMode: true,
		};
		this.rows.push(newRow);
		this.filterTable();
	}

	save(row) {
		row.savingChanges = true;
		if (!this.validateServiceRow(row)) {
			row.savingChanges = false;
			this.toastrService.warning('Not all fields are filled.');
			return;
		}
		const schedule: AddFrequencyModel = new AddFrequencyModel(
			row.editExecutionTime,
			row.editFrequencyId != 4 ? row.editStartDay : null,
			row.editFrequencyId == 4 ? row.editStartWeekDay : null,
			row.editStartMonth
		);
		this.serviceSubscriptionService
			.postFrequencySchedule(schedule)
			.toPromise()
			.then(
				(scheduleResp: any) => {
					if (scheduleResp.id) {
						const scheduleId = scheduleResp.id;
						const subscription: EditServiceSubscriptionModel =
							new EditServiceSubscriptionModel(
								row.id,
								row.editDescription,
								row.editFrequencyId,
								scheduleId,
								row.editIsAutoApproved == 'Yes' ? true : false
							);
						this.serviceSubscriptionService
							.postServiceSubscription(subscription)
							.toPromise()
							.then((subscriptionResp: any) => {
								if (row.id == 0) {
									row.id = subscriptionResp.id;
									const subscriptionServiceTypes: SubscriptionServiceTypeModel[] =
										[];
									row.editServiceTypeIds.forEach((serviceTypeId) => {
										subscriptionServiceTypes.push(
											new SubscriptionServiceTypeModel(
												0,
												subscriptionResp.id,
												serviceTypeId
											)
										);
									});
									this.serviceSubscriptionService
										.setSubscriptionTypeBatch(subscriptionServiceTypes)
										.toPromise()
										.then((subscriptionTypeResp: any) => {
											this.closeEditAfterSave(row);
											row.savingChanges = false;
											this.toastrService.success('New subscription created.');
										});
								} else {
									this.closeEditAfterSave(row);
									row.savingChanges = false;
									this.toastrService.success('Subscription saved.');
								}
							});
					} else {
						this.toastrService.error('Schedule did not save correctly.');
						row.savingChanges = false;
					}
				},
				(err) => {
					this.toastrService.error('Schedule did not save.');
					row.savingChanges = false;
				}
			);
	}

	validateServiceRow(row) {
		if (
			row.editDescription &&
			row.editServiceTypeIds.length > 0 &&
			row.editFrequencyId &&
			row.editFrequencyId != -1 &&
			row.editExecutionTime &&
			row.editStartMonth &&
			(row.editStartDay || row.editStartWeekDay) &&
			row.editIsAutoApproved
		) {
			return true;
		}
		return false;
	}

	archiveSubscription(row) {
		row.savingChanges = true;
		if (row.id == 0) {
			this.rows = this.rows.filter((r) => r.id != row.id);
			this.filterTable();
			return;
		}
		this.confirmDialogService.showConfirm(
			`Do you want to archive this service (${row.description})?`,
			() => {
				this.serviceSubscriptionService
					.patchArchiveServiceSubscription(row.id)
					.toPromise()
					.then((resp) => {
						row.isActive = false;
						this.filterTable();
					});
			},
			() => {
				row.savingChanges = false;
			}
		);
	}

	editModeRate(row) {
		this.closeAllEditRates();
		row.editRateId = row.rateId;
		row.editNoteTemplate = row.noteTemplate;
		row.editMode = !row.editMode;
		this.setRowRate(row);
	}

	closeAllEditRates() {
		this.rows.forEach((r) => {
			if (r.rates) {
				r.rates.forEach((rate) => {
					if (rate.subscriptionRateId == 0) {
						this.archiveRate(rate);
					} else {
						rate.editRateId = rate.rateId;
						rate.editNoteTemplate = rate.noteTemplate;
						rate.editMode = false;
						this.setRowRate(rate);
					}
				});
			}
		});
	}

	setRowRate(row) {
		const dropdownIndex = this.rateDropdown.findIndex(
			(rd) => rd.rateId == (row.editMode ? row.editRateId : row.rateId)
		);
		const subscriptionIndex = this.rows.findIndex(
			(r) => r.id == row.subscriptionId
		);
		const rateIndex = this.rows[subscriptionIndex].rates.findIndex(
			(r) => r.subscriptionRateId == row.subscriptionRateId
		);
		if (dropdownIndex != -1) {
			this.rows[subscriptionIndex].rates[rateIndex].chargeTypeId =
				this.rateDropdown[dropdownIndex].chargeTypeId;
			this.rows[subscriptionIndex].rates[rateIndex].serviceCodeId =
				this.rateDropdown[dropdownIndex].serviceCodeId;
			this.rows[subscriptionIndex].rates[rateIndex].isRecurring =
				this.rateDropdown[dropdownIndex].isRecurring;
			this.rows[subscriptionIndex].rates[rateIndex].isEndOfMonth =
				this.rateDropdown[dropdownIndex].isEndOfMonth;
		} else {
			this.rows[subscriptionIndex].rates[rateIndex].chargeTypeId = null;
			this.rows[subscriptionIndex].rates[rateIndex].serviceCodeId = null;
			this.rows[subscriptionIndex].rates[rateIndex].isRecurring = null;
			this.rows[subscriptionIndex].rates[rateIndex].isEndOfMonth = null;
		}
	}

	saveRate(row) {
		const payload: SetSubscriptionRateModel[] = [
			{
				Id: row.subscriptionRateId,
				SubscriptionId: row.subscriptionId,
				RateId: row.editRateId,
				NoteTemplate: row.editNoteTemplate,
			},
		];
		row.savingChanges = true;
		this.serviceSubscriptionService
			.setSubscriptionRateBatch(payload)
			.toPromise()
			.then(
				(rateResp: any) => {
					row.savingChanges = false;
					this.reloadRates(row.subscriptionId);
					this.toastrService.success('Rate saved.');
				},
				() => {
					row.savingChanges = false;
					this.toastrService.error('Rate did not save.');
				}
			);
	}

	addRate(row) {
		this.closeAllEditRates();
		const newRow = {
			rateId: -1,
			editRateId: -1,
			subscriptionRateId: 0,
			editMode: true,
			subscriptionId: row.id,
		};
		row.rates.push(newRow);
		row.rates = [...row.rates];
	}

	archiveRate(row) {
		if (row.rateId == -1 && row.rateTypeId == null) {
			const index = this.rows.findIndex((r) => r.id == row.subscriptionId);
			this.rows[index].rates = this.rows[index].rates.filter(
				(r) => r.rateId != row.rateId
			);
			return;
		}
		row.savingChanges = true;
		this.serviceSubscriptionService
			.deactivateRate(row.subscriptionId, row.rateId)
			.toPromise()
			.then(
				(result) => {
					this.reloadRates(row.subscriptionId);
					row.savingChanges = false;
				},
				(err) => {
					row.savingChanges = false;
				}
			);
	}

	reloadRates(subscriptionId) {
		const index = this.rows.findIndex((r) => r.id == subscriptionId);
		if (index != -1) {
			this.loadRates(this.rows[index]);
		}
	}

	generateInvoice(row) {
		this.confirmDialogService.showConfirm(
			`Do you want to generate an invoice for subscription "${row.description}" for company ${this.invoiceCompanyId}?`,
			() => {
				this.commonService.showLoader(true);
				this.serviceSubscriptionService
					.generateInvoice(row.id, this.invoiceCompanyId)
					.toPromise()
					.then(
						(resp) => {
							this.commonService.showLoader(false);
							this.toastrService.success('Invoice generated.');
						},
						(err) => {
							this.commonService.showLoader(false);
						}
					);
			},
			() => {}
		);
	}

	getCellClass({ row, column, value }): any {
		if (row.editMode) {
			return ' d-flex align-items-center p-0 m-0';
		}
		return ' d-flex align-items-center';
	}

	restrictMinute(event, row) {
		const selectedHour = event.target.value.substring(0, 2); // Extract hour
		row.editExecutionTime = `${selectedHour}:00`; // Set time to hour:00
	}

	displayChargeType(chargeId) {
		const index = this.chargeTypesList.findIndex((fr) => fr.id == chargeId);
		if (index != -1) {
			return this.chargeTypesList[index].chargeTypeName;
		}
		return '';
	}

	displayServiceCode(serviceCodeId) {
		const index = this.serviceCodeList.findIndex(
			(fr) => fr.serviceCodeId == serviceCodeId
		);
		if (index != -1) {
			return this.serviceCodeList[index].description;
		}
		return '';
	}
	displayServices(serviceIds: number[], serviceRows: any[]): string {
		const filteredRows = serviceRows.filter((sr) => {
			return serviceIds.includes(sr.serviceTypeId);
		});
		let serviceToString = '';
		filteredRows.forEach((fr) => {
			if (serviceToString.length > 0) {
				serviceToString += `, ${fr.serviceName}`;
			} else {
				serviceToString = fr.serviceName;
			}
		});
		return serviceToString;
	}

	displayFrequency(frequencyId: number, frequencyRows: any[]): string {
		const index = frequencyRows.findIndex((fr) => fr.id == frequencyId);
		if (index != -1) {
			return frequencyRows[index].frequencyName;
		}
		return '';
	}

	displayDay(dayNum, frequencyId) {
		let dayName = '';
		if (frequencyId == 4) {
			switch (dayNum) {
				case 1: {
					dayName = 'Sunday';
					break;
				}
				case 2: {
					dayName = 'Monday';
					break;
				}
				case 3: {
					dayName = 'Tuesday';
					break;
				}
				case 4: {
					dayName = 'Wednesday';
					break;
				}
				case 5: {
					dayName = 'Thursday';
					break;
				}
				case 6: {
					dayName = 'Friday';
					break;
				}
				case 7: {
					dayName = 'Saturday';
					break;
				}
				default: {
					break;
				}
			}
		} else {
			dayName += `${dayNum}`;
			switch (dayNum) {
				case 1: {
					dayName += 'st';
					break;
				}
				case 2: {
					dayName += 'nd';
					break;
				}
				case 3: {
					dayName += 'rd';
					break;
				}
				default: {
					dayName += 'th';
					break;
				}
			}
		}
		return dayName;
	}
	displayMonth(monthNum: number): string {
		let monthName = '';
		switch (monthNum) {
			case 1: {
				monthName = 'January';
				break;
			}
			case 2: {
				monthName = 'February';
				break;
			}
			case 3: {
				monthName = 'March';
				break;
			}
			case 4: {
				monthName = 'April';
				break;
			}
			case 5: {
				monthName = 'May';
				break;
			}
			case 6: {
				monthName = 'June';
				break;
			}
			case 7: {
				monthName = 'July';
				break;
			}
			case 8: {
				monthName = 'August';
				break;
			}
			case 9: {
				monthName = 'September';
				break;
			}
			case 10: {
				monthName = 'October';
				break;
			}
			case 11: {
				monthName = 'November';
				break;
			}
			case 12: {
				monthName = 'December';
				break;
			}
			default: {
				break;
			}
		}
		return monthName;
	}
}



// WEBPACK FOOTER //
// ./src/app/developer/components/service-subscription-editor/service-subscription-editor.component.ts